/**
 * 走行軌跡のイベント設定
 */

// グローバル変数
var _movement_locus_settings_ = false;
var _movement_locus_data_     = false;

window.movement_locus_event_set = function ()
{
    var _zMapMain = $('#map');

    // 地図要素が無い時は何もしない
    if (_zMapMain.length <= 0) {
        return;
    }

    /** 画面初期化処理 */
    _movement_locus_settings_ = {
        url_get_movement_locus_data: url_get_movement_locus_data,
        url_set_default_locus_filter_data: url_set_default_locus_filter_data,
        url_get_locus_record_option_data: url_get_locus_record_option_data,
        url_temperature_print : url_temperature_print,
        url_drive_recorder_viewer : url_drive_recorder_viewer,
        messages: {
            /** 作業イベント・警告イベントアイコン吹き出し表示用 */
            e_infobox: movement_base.e_infobox,
            /** 地点アイコン吹き出し表示用 */
            d_infobox: movement_base.d_infobox,
            /** 作業イベント・警告イベントリスト表示用 */
            info_list: movement_config.movement_locus.info_list.options,
            /** イベント種別ID */
            event_id_messages: movement_base.event_ids,
            /** イベント区分 */
            event_types: movement_base.event_types,
            /** 地点区分(行先区分) */
            destination_types: movement_base.destination_types,
            /** 情報表示エリア表示・非表示ボタン */
            right_area_show_button: movement_locus.right_area_show_button,
            right_area_hide_button: movement_locus.right_area_hide_button,
            /** イベント詳細内訳欄オプション */
            event_detail_options: movement_locus.search_area2.event_detail.options,
            /** 車両状態 */
            vehicle_status_types: movement_base.vehicle_status_types,
            /** 実車／空車区分 */
            luggage_status_types: movement_base.luggage_status_types,
            /** km/h */
            speed_unit: movement_config.unit.speed,
        },
    };
    initialize();

    /**
     * 画面の初期化処理を行います。
     */
    function initialize()
    {
        //-----------------------------
        // init
        //-----------------------------
        // right_area init
        $("#right_area_upper").css('padding-bottom', '0px').height("100%");

        /** 日報修正からジャンプした場合(起動モード1)の事前処理 */
        presetMode1();

        /** 内部変数初期化 */
        _movement_locus_data_ = false;

        /** エラーメッセージ表示のリセット */
        resetErrorMessage();

        /** 地図初期化 */
        initializeMap();

        /** 情報表示エリア表示化 */
        showRightAreaContainer();

        /** 情報リスト初期化処理 */
        initializeInfoList();

        /** 絞り込み条件欄の初期化 */
        clearInputFilterEvents();

        /** 日時の初期値を月初〜当日(現在時刻)に設定 */
        const now = moment();
        const startOfMonth = now.clone().startOf('month').startOf('day');
        const endOfToday = now.clone().endOf('day');
        const timeFromInput = $('#locus_search_area-time_from');
        const timeToInput = $('#locus_search_area-time_to');
        if (timeFromInput.length && !timeFromInput.val()) {
            timeFromInput.val(startOfMonth.format('YYYY/MM/DD HH:mm'));
        }
        if (timeToInput.length && !timeToInput.val()) {
            timeToInput.val(endOfToday.format('YYYY/MM/DD HH:mm'));
        }

        /** 画面リサイズ処理 */
        resizeDisplay();

        /** 日報修正からジャンプした場合(起動モード1)の初期表示処理 */
        setInputMode1();

        //-----------------------------
        // add event
        //-----------------------------
        /** 画面リサイズ時イベントの描画処理を行います。 */
        $( window ).on('resize', function(){
            resizeDisplay();
        });

        /** サイドバー切替ボタン押下時のイベント処理を行います */
        $(document).on('click', '.sidebar-control', function()
        {
            setTimeout(function(){
                if (_zMapMain.mapLocus){
                    _zMapMain.mapLocus.resizeMap();
                }
            }, 400);
        });

        /** 検索条件営業所変更時 */
        $(document).on('change', '#locus_search_area-section_id', function () {
            setRecordOptions();
        });

        /** 検索条件車両変更時 */
        $(document).on('change', '#locus_search_area-vehicle_id', function () {
            setRecordOptions();
        });

        /** 検索条件発生日時変更時 */
        $(document).on('change', '#locus_search_area-time_from, #locus_search_area-time_to', function () {
            setRecordOptions();
        });

        /** 検索ボタン押下時イベントの処理を行います。 */
        $(document).on('click', '#search_area1 #search_button', function()
        {
            /** 警告選択時の確認ダイアログ */
            var warn_enabled = $('#locus_search_area-warn_enabled');
            if (warn_enabled.prop('checked')) {
                if (!confirm(warn_enabled.data('alert'))) {
                    return;
                }
            }

            /** 走行軌跡データ取得 */
            getMovementLocusData();
        });

        /** クリアボタン押下時イベントの処理を行います。 */
        $(document).on('click', '#search_area1 #clear_button', function()
        {
            /** データ初期化 */
            _movement_locus_data_ = false;
            /** エラーメッセージ表示のリセット */
            resetErrorMessage();
            /** 検索条件欄の初期化 */
            $('#locus_search_area-section_id:not(:disabled)').val('').trigger("change");
            $('#locus_search_area-vehicle_id:not(:disabled)').val('').trigger("change");
            $('#locus_search_area-time_from:not(:disabled)').val('').trigger('change');
            $('#locus_search_area-time_to:not(:disabled)').val('').trigger('change');
            $('#locus_search_area-record_id:not(:disabled)').empty().append(new Option('---', '', true, true)).trigger('change');
            $('#locus_search_area-warn_enabled').prop('checked', false).trigger('change');
            $('#locus_search_area-temp_enabled').prop('checked', false).trigger('change');

            /** 地図表示リセット */
            resetMap(true);
            /** 情報リスト初期化処理 */
            initializeInfoList();
            /** 絞り込み条件欄の初期化 */
            clearInputFilterEvents();
        });

        /** 絞り込み条件変更時イベント(イベント区分) */
        $(document).on('change', '#search_area2 input[name="event_types[]"]', function()
        {
            /** イベント区分の選択状態の保存 */
            setDefaultLocusFilterData();

            /** イベント詳細内訳欄の更新 */
            refreshDropdownListEvents(_movement_locus_settings_.messages);

            /** 指定条件でイベントリストのフィルター設定 */
            setFilterInfoListEvents();

            // 温度グラフUI初期化
            $('#locus_search_area_temp_open').prop('disabled', true);
            $('#all-check').prop('checked', false);
            $('.graph-display-check').prop('checked', false);
        });

        /** 絞り込み条件変更時イベント(イベント詳細内訳) */
        $(document).on('change', '#search_area2 #event_detail', function()
        {
            /** 指定条件でイベントリストのフィルター設定 */
            setFilterInfoListEvents();
            // 温度グラフUI初期化
            $('#locus_search_area_temp_open').prop('disabled', true);
            $('#all-check').prop('checked', false);
            $('.graph-display-check').prop('checked', false);
        });

        /**
         * リストヘッダクリック(ソート)
         */
        $(document).on('click', '#info_list_table th.sorting, th.sorting_asc, th.sorting_desc', function(e)
        {
            let key = $(this).data('sort_key');
            let type = $(this).parents('table').data('type');
            $('#locus_search_area_temp_open').prop('disabled', true);
            onClickThInfoList(type, "#th_" + key);
        });

        /**
         * リスト行クリック
         * 選択行style＆地図上POPUP制御
         */
        $(document).on('click', '#info_list_table tbody tr', function(e)
        {
            /* 行のクリックイベント */
            let rowId = $(this).data('row_id');
            let type = $(this).data('type');
            let event_id   = $(this).attr('event_id');

            if(event_id === 'DR05110001'
                || event_id === 'DR05110002'
                || event_id === 'DR05120001'
                || event_id === 'DR05120002'
            ) {
                return false;
            }

            if (!$(this).hasClass('info_list-tr-selected')){
                /** 選択されていない場合 */

                /** 選択行の背景色を選択色に変更 */
                $(this).parent().children('tr').removeClass('info_list-tr-selected');    // 全行選択色リセット
                $(this).addClass('info_list-tr-selected');                               // 当該行に選択色セット

                /** 選択行に対応するアイコンの吹き出しを表示 */
                _zMapMain.mapLocus.closeInfoboxEventAll();
                _zMapMain.mapLocus.closeInfoboxDestinationAll();
                _zMapMain.mapLocus.openInfoboxEvent(type, rowId);

            } else {
                /** 既に選択されている場合 */

                /** 当該行選択色リセット */
                $(this).removeClass('info_list-tr-selected');                            // 当該行の選択色リセット

                /** 当該行に対応するアイコンの吹き出しを閉じる */
                _zMapMain.mapLocus.closeInfoboxEvent(type, rowId);
            }

            return false;
        });

        /**
         * 温度グラフ関係制御
         */
        // 温度記録表PDFOPEN
        $(document).on('click', '#locus_search_area_temp_open', function (e)
        {
            e.stopPropagation();
            let action = _movement_locus_settings_.url_temperature_print;
            // 選択レコードの日付範囲を取得
            let selectEvent = $('input.graph-display-check:checked');
            let from = null;
            let to = null;
            selectEvent.each(function() {
                if (from === null || from > $(this).val()) {
                    from = $(this).val();
                }
                if (to === null || to < $(this).val()) {
                    to = $(this).val();
                }
            });
            let params = $('#locus_search-form').serializeArray();
            // TODO: BS-2457 service/printing_reportをCALL パラメータ仕様はGBCに則る 変更の場合は別途対応のこと
            params.push({ name: 'start_time', value: moment($('#locus_search_area-time_from').val()).format('YYYY-MM-DD HH:mm:00') });
            params.push({ name: 'end_time', value: moment($('#locus_search_area-time_to').val()).format('YYYY-MM-DD HH:mm:59') });
            params.push({ name: 'start_time2', value: moment(from).format('YYYY-MM-DD HH:mm:ss') });
            params.push({ name: 'end_time2', value: moment(to).format('YYYY-MM-DD HH:mm:ss') });
            params.push({ name: 'ch1', value: $("#input-temp_ch1").prop("checked") ? 1 : 0 });
            params.push({ name: 'ch2', value: $("#input-temp_ch2").prop("checked") ? 1 : 0 });
            params.push({ name: 'report_type', value: 'chart2' });  // 固定
            params.push({ name: 'jump_page', value: '' });          // 固定
            params.push({ name: 'is_fukuyama', value: 0 });         // 固定
            params.push({ name: 'is_serverside_pdf', value: 1 });   // 固定
            params.push({ name: 'report_format', value: 0 });       // 固定
            // BlobでPDFを別ウィンドウで表示
            _ajax.blob(action, params, function (blob) {
                if (blob && blob instanceof Blob && blob.size > 0) {
                    window.open(window.URL.createObjectURL(blob), '_blank');
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        });

        // ch選択
        $(document).on('click', '#input-temp_ch1, #input-temp_ch2', function (e)
        {
            e.stopPropagation();
            let checkedSize = $('.graph-display-check:checked').length;
            let chChecked = $('#input-temp_ch1').prop('checked') || $('#input-temp_ch2').prop('checked');
            // 表示ボタンON/OFF
            if (chChecked && checkedSize >= 2) {
                $('#locus_search_area_temp_open').prop('disabled', false);
            } else {
                $('#locus_search_area_temp_open').prop('disabled', true);
            }
        });

        // グラフ対象全選択
        $(document).on('click', '#all-check', function (e)
        {
            e.stopPropagation();
            let checked = $('#all-check').prop('checked');
            let checks = $('.graph-display-check');
            let chChecked = $('#input-temp_ch1').prop('checked') || $('#input-temp_ch2').prop('checked');
            checks.prop('checked', checked);
            if (checked && chChecked) {
                $('#locus_search_area_temp_open').prop('disabled', false);
            } else {
                $('#locus_search_area_temp_open').prop('disabled', true);
            }
        });

        // グラフ対象選択
        $(document).on('click', '.graph-display-check', function (e)
        {
            e.stopPropagation();
            let allCheck = $('#all-check');
            let checkGroup = $('.graph-display-check');
            let checked = $('.graph-display-check:checked');
            let chChecked = $('#input-temp_ch1').prop('checked') || $('#input-temp_ch2').prop('checked');
            // クリック対象と前後チェック範囲を全てをクリック対象とする
            let here = checkGroup.index(this);
            if (checked.length >= 2) {
                let first = checkGroup.index(checked.not(this).first());
                if (here > first) {
                    while (first < here) {
                        checkGroup.eq(first).prop('checked', $(this).prop('checked'));
                        first = first + 1;
                    }
                } else {
                    while (here < first) {
                        checkGroup.eq(here).prop('checked', $(this).prop('checked'));
                        here = here + 1;
                    }
                }
            }
            // check reload
            checked = $('.graph-display-check:checked')
            // 全選択チェックON/OFF
            if (checked.length === checkGroup.length) {
                allCheck.prop('checked', true);
            } else {
                allCheck.prop('checked', false);
            }
            // グラフ表示ボタンON/OFF
            if (chChecked && checked.length >= 2) {
                $('#locus_search_area_temp_open').prop('disabled', false);
            } else {
                $('#locus_search_area_temp_open').prop('disabled', true);
            }
        });

        /*---- CSVダウンロード時 ----*/

        // CSVダウンロード時
        $(document).on('click', '#search_area1 #csv_download', function () {
            // アクションの取得
            let action = extend_url_query($(this).data('action'));
            /** 検索パラメータ―セット */
            let params = $('#locus_search-form').serializeArray();
            params.push({ name: 'time_from', value: moment($('#locus_search_area-time_from').val()).format('YYYY/MM/DD HH:mm:00') });
            params.push({ name: 'time_to', value: moment($('#locus_search_area-time_to').val()).format('YYYY/MM/DD HH:mm:59') });
            // ポスト送信を実行
            post(action, params);
        });

        /**
         * ドラレコ詳細 動画データの詳細モーダルをCALL
         */
        $(document).on('click', '.show-drive-recorder', function (e)
        {
            e.stopPropagation();
            let tr = $(this).parents('tr');
            if (tr.length === 0) {
                return false;
            }
            // パラメタ編集
            let params = {
                // 'id' : tr.data('row_id').split('_')[1],
                'warning_id' : tr.data('row_id').split('_')[1],
                'section_id' : tr.data('section_id'),
                'record_id' : tr.data('record_id') || '',
                'unit' : 'basic_summary',
            };
            _modal.create_with_data(this, 'drive_recorder-viewer-modal', params, true, function() {
                /** 動画再生用Viewer初期化 */
                record_data_modal_event_set('drive_recorder-viewer-modal');
            });

            return false;
        });

        //-----------------------------
        // map event
        //-----------------------------
        /** 情報表示エリア表示ボタン押下時イベントの処理を行います。 */
        _zMapMain.on("mapLocus:onclickRightareaShowButton",function(e)
        {
            /** 情報表示エリアを表示 */
            showRightAreaContainer();
            resizeDisplay();

            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

        /**
         * 情報表示エリア非表示ボタン押下時イベントの処理を行います。
         */
        _zMapMain.on("mapLocus:onclickRightareaHideButton",function(e){

            /** 情報表示エリアを隠す */
            hideRightAreaContainer();
            resizeDisplay();

            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

        /**
         * 地図のイベントアイコンの吹き出し表示を開いた時のイベント処理を行います。
         */
        _zMapMain.on("markerEvent:openedInfoBox",function(e, marker_type, marker_id){

            let type        = marker_type || '';
            let rowId       = marker_id || '';
            let tr          = $('#info_list_table tr[data-row_id="' + rowId + '"]');
            if (tr) {
                /** 対象行の背景色を選択色に変更 */
                tr.addClass('info_list-tr-selected');                               // 当該行に選択色セット
            }
        });

        /**
         * 地図のイベントアイコンの吹き出し表示を閉じた時のイベント処理を行います。
         */
        _zMapMain.on("markerEvent:closedInfoBox",function(e, marker_type, marker_id){

            let type        = marker_type || '';
            let rowId       = marker_id || '';
            let tr          = $('#info_list_table tr[data-row_id="' + rowId + '"]');
            if (tr) {
                /** 対象行の背景色を選択色をリセット */
                tr.removeClass('info_list-tr-selected');                          // 当該行の選択色リセット
            }
        });

        /**
         * 地図の地点アイコンの吹き出し表示を開いた時のイベント処理を行います。
         */
        _zMapMain.on("markerDestination:openedInfoBox",function(e, marker_type, marker_id){
        });

        /**
         * 地図の地点アイコンの吹き出し表示を閉じた時のイベント処理を行います。
         */
        _zMapMain.on("markerDestination:closedInfoBox",function(e, marker_type, marker_id){
        });
    }

    function setRecordOptions()
    {
        let recordId = $('#locus_search_area-record_id');
        // クリア
        recordId.empty().append(new Option('---', '', true, true));
        // CSVダウンロードOFF
        $('#csv_download').prop('disabled', true);

        /** 記録ID選択欄の初期化処理 */
        recordId.select2({
            allowClear: true,
            placeholder :'---',
            width: '100%',
            language: {
                errorLoading: function() {
                    return '対象が見つかりません';
                }
            },
            ajax: {
                url: extend_url_query(_movement_locus_settings_.url_get_locus_record_option_data),
                dataType: 'json',
                data:  {
                    page: 1,
                    holding_id: $('#locus_search_area-holding_id').val(),
                    company_id: $('#locus_search_area-company_id').val(),
                    section_id: $('#locus_search_area-section_id').val(),
                    vehicle_id: $('#locus_search_area-vehicle_id').val(),
                    time_from: moment($('#locus_search_area-time_from').val()).format('YYYY/MM/DD HH:mm:00'),
                    time_to: moment($('#locus_search_area-time_to').val()).format('YYYY/MM/DD HH:mm:59'),
                    model: 'vehicle',
                },
                cache: true
            }
        });
    }

    /**
     * 画面リサイズ処理を行います。
     */
    function resizeDisplay()
    {
        let windowHeight  = $(window).height();
        let headerHeight  = $('.main-header').first().height();
        let titleHeight   = 0;      //$('.content-header').first().height();
        let menuHeight    = $('.movement-menu').height();
        let footerHeight  = 0;      //$('.main-footer').first().height();
        let paddingHeight = 42;     //58;
        let totalHeight   = windowHeight - (headerHeight + titleHeight + menuHeight + footerHeight) - paddingHeight;

        $('#main_container').height(totalHeight);
        $('#left_area').height(totalHeight);
        $('#right_area').height(totalHeight);
    }

    /**
     * 情報表示エリアを表示します。
     */
    function showRightAreaContainer()
    {
        /** ボタンの表示・非表示切替え */
        _zMapMain.mapLocus.showRightareaButton(2);

        /** リサイズバーを表示(左右エリア間) */
        $('#left_area').resizable({
            handles: 'e',
            resize: function( event, ui ) {
                _zMapMain.mapLocus.resizeMap();
            },
            stop: function( event, ui ) {
                _zMapMain.mapLocus.resizeMap();
            },
        });

        /** 左側エリアを縮小 */
        $('#left_area').animate({width: "55%"}, 500, function(){
            _zMapMain.mapLocus.resizeMap();
        });

        /** 右側エリアを拡大 */
        $('#right_area').show().animate({width: "45%"}, 500, function(){
        });

    }

    /**
     * 情報表示エリアを非表示にします。
     */
    function hideRightAreaContainer()
    {
        /** ボタンの表示・非表示切替え */
        _zMapMain.mapLocus.showRightareaButton(1);

        /** リサイズバーをクリア(左右エリア間) */
        if( $('#left_area').hasClass('ui-resizable')){
            $('#left_area').resizable('destroy');
        }

        /** 右側エリアを縮小 */
        $('#right_area').animate({width: "0%"}, 500, function(){
            $('#right_area').hide();
        });

        /** 左側エリアを拡大 */
        $('#left_area').animate({width: "100%"}, 500, function(){
            _zMapMain.mapLocus.resizeMap();
        });
    }

    /**
     * 地図を初期化します。
     */
    function initializeMap()
    {
        _zMapMain.mapLocus.init(_movement_locus_settings_);
    }

    /**
     * 地図表示をリセットします。
     * @param {*} isResetHome
     */
    function resetMap(isResetHome)
    {
        _zMapMain.mapLocus.resetMap(isResetHome);
    }

    /**
     * 検索結果リストを初期化します。
     */
    function initializeInfoList()
    {
        /** イベントリストクリア */
        clearInfoListEvents();
        // 温度グラフUI初期化
        $('#locus_search_area_temp_open').prop('disabled', true);
        $('#input-temp_ch1, #input-temp_ch2').prop('checked', true);
        $('#all-check').prop('checked', false);
        $('.graph-display-check').prop('checked', false);
        // CSVダウンロードOFF
        $('#csv_download').prop('disabled', true);

    }

    /**
    * 走行軌跡データを取得します。
    */
    function getMovementLocusData()
    {
        /** データ初期化 */
        _movement_locus_data_ = false;
        /** エラーメッセージ表示のリセット */
        resetErrorMessage();
        /** 地図表示リセット */
        resetMap(true);
        /** 情報リスト初期化処理 */
        initializeInfoList();
        /** 絞り込み条件欄の初期化 */
        clearInputFilterEvents();

        /** 検索パラメータ―セット */
        let action = extend_url_query(_movement_locus_settings_.url_get_movement_locus_data);
        let params = {
            holding_id: $('#locus_search_area-holding_id').val(),
            company_id: $('#locus_search_area-company_id').val(),
            section_id: $('#locus_search_area-section_id').val(),
            vehicle_id: $('#locus_search_area-vehicle_id').val(),
            time_from: moment($('#locus_search_area-time_from').val()).format('YYYY/MM/DD HH:mm:00'),
            time_to: moment($('#locus_search_area-time_to').val()).format('YYYY/MM/DD HH:mm:59'),
            record_id: $('#locus_search_area-record_id').val(),
            warn_enabled: $('#locus_search_area-warn_enabled:checked').val(),
            temp_enabled: $('#locus_search_area-temp_enabled:checked').val(),
        };
        _ajax.post(action, params, function(data) {
            /** エラー時はメッセージを表示して終了 */
            if (data && data.errors && Object.keys(data.errors).length) {
                /** エラーメッセージ設定 */
                setErrorMessage(data.errors);

                return;
            }

            // 走行データ表示
            _movement_locus_data_ = data;
            _zMapMain.mapLocus.setMapData(data);
            /** 並べ替えデータ取得 */
            data['list_events'] = getSortDataEvents(data['list_events'], 'event_time', 1);
            /** リスト作成 */
            createInfoList(data);
            /** 並べ替えアイコンを設定 */
            setSortIconInfoListEvents('time', 1);
            /** イベント詳細内訳欄の更新 */
            refreshDropdownListEvents(_movement_locus_settings_.messages);
            /** フィルター設定を実行 */
            resetFilterInfoListEvents();
            setFilterInfoListEvents();
            // CSVダウンロードON
            $('#csv_download').prop('disabled', false);

        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });

    }

    /**
    * 表示リストを生成します。
    * @param {*} data
    */
    function createInfoList(data)
    {
        /** イベントリスト生成 */
        createInfoListEvents(data['list_events']);
    }

    /**
    * イベントリストを生成します。
    * @param {*} list
    */
    function createInfoListEvents(list)
    {
        // const
        // 速度超過
        const OVER_SPEED_EVENTS =
            [
                'EV01040001',
                'EV01041001',
                'EV01040101',
                'EV01041101',
                'EV01040201',
                'EV01041201',
                'EV01040301',
                'EV01040301',
                'EV01040301',
                'EV01041301',
            ];
        const ALC_EVENTS = [
            'EV03010001',
            'EV03010101'
        ];

        // init
        let listBlock = $('#info_list_events');
        listBlock.empty();

        let warn_enabled = $('#locus_search_area-warn_enabled').prop('checked');
        let temp_enabled = $('#locus_search_area-temp_enabled').prop('checked');

        // 警告を表示非表示
        if (warn_enabled) {
            $("#event_type_2").parent('label').removeClass('d-none');
        } else {
            $("#event_type_2").parent('label').addClass('d-none');
        }
        // 温度情報表示非表示
        if (temp_enabled) {
            $("#temp-block").removeClass('d-none');
            $("#event_type_4").parent('label').removeClass('d-none');
        } else {
            $("#temp-block").addClass('d-none');
            $("#event_type_4").parent('label').addClass('d-none');
        }

        if ($(list).length === 0) {
            return;
        }

        // setting
        let listSettings = _movement_locus_settings_.messages.info_list;
        let table  = $('<table id="info_list_table" class="table table-bordered table-hover dataTable info_list-table" role="list"></table>');

        /** ヘッダ部 **/
        let thead = $('<thead></thead>');
        let tbody = $('<tbody></tbody>');
        let tr = $('<tr role="row"></tr>');

        // tr処理
        if (temp_enabled) {
            tr.append($('<th class="text-center sorting_disabled"><input type="checkbox" id="all-check" /></th>'));
        }
        $.each(listSettings, function(key, value) {
            let sorting = (value.hasOwnProperty('sorting') && value.sorting === true) ? 'sorting' : 'sorting_disabled';
            if (key === 'temperature1' || key === 'temperature2' || key === 'temperature3' || key === 'temperature4') {
                if (temp_enabled) {
                    tr.append($('<th id="th_' + key + '" class="' + sorting + '" data-sort_key="' + key + '">' + value.label + '</th>'))
                }
            } else {
                tr.append($('<th id="th_' + key + '" class="' + sorting + '" data-sort_key="' + key + '">' + value.label + '</th>'))
            }
        });
        thead.append(tr);
        table.append(thead);

        /** ボディ部 */
        $(list).each(function(i, item) {
            // イベント付加情報編集
            let event_info = '';
            let event_status = '';
            if (OVER_SPEED_EVENTS.indexOf(item.event_id) >= 0){
                event_info = ' [速度: ' + item.speed + ' km/h]';
            } else if (ALC_EVENTS.indexOf(item.event_id) >= 0){
                event_info = ' [' + item.event_status + ']';    // ALC側なし
            }
            if (item.event_status) {
                if (item.event_status.toString() === '1') {
                    event_status = "（予冷）";
                }else if (item.event_status.toString() === '2') {
                    event_status = "（積置）";
                }
            }
            // 速度
            let speed = "";
            if (item.speed != null) {
                speed = item.speed + _movement_locus_settings_.messages.speed_unit;
            } else if (item.average_speed != null) {
                speed = item.average_speed + _movement_locus_settings_.messages.speed_unit;
            }

            let _rowId = item.event_type + '_' + item.id.toString();
            let _type = 1;
            // 表示データ編集
            let _display = {};
            _display['time'] = moment(item.time).format('MM/DD HH:mm');
            _display['event_id'] = getEventIdMessage(item.event_id) + event_info + event_status;
            _display['event_type'] = getEventTypeMessage(item.event_type);
            _display['speed'] = speed;
            _display['temperature1'] = item.temperature1 === '3276.7' ? '---℃' : (item.temperature1 || '');
            _display['temperature2'] = item.temperature2 === '3276.7' ? '---℃' : (item.temperature2 || '');
            _display['temperature3'] = item.temperature3 === '3276.7' ? '---℃' : (item.temperature3 || '');
            _display['temperature4'] = item.temperature4 === '3276.7' ? '---℃' : (item.temperature4 || '');

            // tr生成
            tr = $('<tr role="row" data-type="' + _type + '" data-row_id="' + _rowId + '"></tr>');
            // td処理
            if (temp_enabled) {
                tr.append($('<td class="text-center"><input type="checkbox" class="graph-display-check" id="graph-display-' + i + '" value="' + item.time + '" /></td>'));    // チェックボックス
            }
            $.each(listSettings, function(key, value) {
                if (key === 'temperature1' || key === 'temperature2' || key === 'temperature3' || key === 'temperature4') {
                    if (temp_enabled) {
                        tr.append($('<td class="display-' + key + ' ' + (value.td_class || '') + '">' + (_display[key] || '') + '</td>'));
                    }
                } else if (key === 'drive_detail') {
                    tr.append($('<td class="info_list-td-center display-' + key + ' ' + (value.td_class || '') + '">' + (
                        (item.event_type.toString() === '3') ?
                            '<a class="show-drive-recorder info_list-table-td-btn-mark" ' +
                            'href="javascript:void(0)" ' +
                            'data-action="' + _movement_locus_settings_.url_drive_recorder_viewer + '" ' +
                            'data-drive_recorder-viewer-modal="#drive_recorder-viewer-modal" role="button">' +
                            '<i class="fa fa-video"></i>' +
                            '</a>'
                        :
                            ''
                        ) +
                    '</td>'));  // ドラレコ撮影
                } else {
                    tr.append($('<td class="display-' + key + ' ' + (value.td_class || '') + '">' + (_display[key] || '') + '</td>'));
                }
            });
            // リスト表示設定以外の内部パラメタ項目data属性追加
            // TODO:全て必要か精査
            tr.attr('data-record_id', (item.record_id || ''));
            tr.attr('data-section_id', (item.section_id || ''));
            tr.attr('data-vehicle_id', (item.vehicle_id || ''));
            tr.attr('data-event_time', (item.time || ''));
            tr.attr('data-event_type', (item.event_type || ''));
            tr.attr('data-event_id', (item.event_id || ''));
            tr.attr('data-latitude', (item.latitude || ''));
            tr.attr('data-longitude', (item.longitude || ''));
            tr.attr('data-camera_count', (item.camera_count || ''));
            tr.attr('data-digitacho_model', (item.digitacho_model || ''));
            tr.attr('data-model', (item.model || ''));
            tbody.append(tr);
        });
        table.append(tbody);
        //------------------------------------------------------------
        listBlock.append(table);
    }

    /**
    * イベントリストをクリアします。
    */
    function clearInfoListEvents()
    {
        /** ヘッダを残して一覧をクリア(空データで一覧を再作成) */
        createInfoListEvents(null);

        /** 並べ替えアイコンを設定 */
        setSortIconInfoListEvents('time', 1);

        _movement_locus_data_ = false;
    }

    /**
     * イベント種別メッセージを取得します。
     * @param {*} event_id
     */
    function getEventIdMessage(event_id)
    {
        let _event_id = (event_id || '').toString();
        let message = _event_id;

        if(_movement_locus_settings_.messages.event_id_messages.hasOwnProperty(_event_id)){
            message = _movement_locus_settings_.messages.event_id_messages[_event_id];
        }
        return message;
    }

    /**
     * イベント区分メッセージを取得します。
     * @param {*} event_type
     */
    function getEventTypeMessage(event_type)
    {
        let _event_type = (event_type || '').toString();
        let message = _event_type;

        if(_movement_locus_settings_.messages.event_types.hasOwnProperty(_event_type)){
            message = _movement_locus_settings_.messages.event_types[_event_type];
        }
        return message;
    }

    /**
     * 指定条件でイベントリストのフィルター設定を行います。
     */
    function setFilterInfoListEvents()
    {
        /** 絞り込み条件の取得 */
        let event_types = {
            1: !!$('#event_type_1').prop('checked'),  // イベント区分(1.作業)
            2: !!$('#event_type_2').prop('checked'),  // イベント区分(2.警告)
            3: !!$('#event_type_3').prop('checked'),  // イベント区分(3.撮影)
            4: !!$('#event_type_4').prop('checked'),  // イベント区分(4.定期送信)
        };
        // イベント詳細内訳
        let event_ids = $('#event_detail').val() || [];

        /** 条件に一致する対象IDの取得・リスト表示の更新 */
        let target_ids  = [];
        let list        = _movement_locus_data_ ? _movement_locus_data_['list_events'] : [];
        $(list).each(function(i, item) {

            let is_target1  = false;    // 絞り込み判定用(イベント区分)
            let is_target2  = false;    // 絞り込み判定用(イベント詳細内訳)

            /** イベント区分絞り込み */
            if (((item.event_type || '').toString() === '1' && event_types[1]) ||
                ((item.event_type || '').toString() === '2' && event_types[2]) ||
                ((item.event_type || '').toString() === '3' && event_types[3]) ||
                ((item.event_type || '').toString() === '4' && event_types[4])) {

                    is_target1 = true;
            }

            /** イベント詳細内訳絞り込み */
            if (event_ids && event_ids.length === $('#event_detail option').length) {
                is_target2 = true;
            } else if (event_ids) {
                if (event_ids.includes((item.event_id || '').toString())) {
                    is_target2 = true;
                }
            }

            /** 全ての判定条件を満たす場合は表示対象 */
            let rowId   = item.event_type + '_' + item.id.toString();      // イベント区分＋イベントID
            let tr      = $('#info_list_table tr[data-row_id="' + rowId + '"]');
            if (tr) {
                if (is_target1 && is_target2) {
                    /** リストの対象行の表示化 */
                    tr.removeClass('d-none');
                    /** 表示対象として行IDを取得 */
                    target_ids.push(rowId);
                } else {
                    /** リストの対象行の非表示化 */
                    tr.addClass('d-none');
                }
            }
        });

        /** 地図アイコンのフィルター設定 */
        _zMapMain.mapLocus.setFilterModeEvents(target_ids);            // イベントアイコン
        _zMapMain.mapLocus.resetFilterModeDestinations();              // 地点アイコンはリセット
    }

    /**
     * イベントリストのフィルター設定を解除します。
     */
    function resetFilterInfoListEvents()
    {
        /** リストのフィルター設定を一括解除 */
        let list = _movement_locus_data_ ? _movement_locus_data_['list_events'] : null;
        if (list){
            $(list).each(function(i, item){
                let rowId   = item.event_type + '_' + item.id.toString();      // イベント区分＋イベントID
                let tr      = $('#info_list_table tr[data-row_id="' + rowId + '"]');
                if (tr) {
                    tr.removeClass('d-none');
                }
            });
        }
        /** 地図アイコンのフィルター設定を一括解除 */
        _zMapMain.mapLocus.resetFilterModeEvents();               // イベントアイコン
        _zMapMain.mapLocus.resetFilterModeDestinations();         // 地点アイコン
    }

    /**
    * イベントリストの絞り込み条件をクリアします。
    */
    function clearInputFilterEvents()
    {
        /** 絞り込み条件欄のクリア */
        let event_detail = $('#event_detail');
        let locus_filter_event_types = $('#locus_filter_event_types').val() || '';
        if (locus_filter_event_types === '') {
            $('input[name="event_types[]"]').prop('checked', true);
        } else {
            let event_types = JSON.parse(locus_filter_event_types);
            $.each(event_types, function(key, val) {
                $('input:checkbox[name="event_types[]"][value="' + key + '"]').prop('checked', val === 'true');
            });
        }

        event_detail.empty().trigger('change'); // イベント詳細内訳
        event_detail.multipleSelect('refresh');
    }

    /**
     * イベント詳細内訳ドロップダウンリストを生成します。
     * @param {*} list
     * @param {*} event_types
     * @param {*} messages
     */
    function createDropdownListEvents(list, event_types, messages)
    {
        let event_detail = $('#event_detail');
        /** 既存のドロップダウンリストをクリア */
        event_detail.empty().trigger('change');
        event_detail.multipleSelect('refresh');
        event_detail.multipleSelect('refreshOptions', {
            placeholder: messages.event_detail_options.placeholder,
            formatSelectAll: function() {
                return messages.event_detail_options.selectAll;
            },
            formatAllSelected: function() {
                return messages.event_detail_options.selectedAllOptions;
            }
        });

        if (list) {
            /** 取得データでドロップダウンリストを作成 */
            Object.keys(list).forEach(function (key) {
                let event_type  = list[key];
                let event_type_message = getEventTypeMessage(event_type);
                let event_id    = key;
                let event_id_message   = getEventIdMessage(event_id);
                if (event_types.includes(event_type)) {
                    event_detail.append("<option "
                                + "value='" + event_id + "' "
                                + ">"
                                + '[' + event_type_message + '] ' + event_id_message
                                + "</option>");
                }
            });
            event_detail.trigger('change');
        }

        $('#event_detail option').attr('selected', 'selected');
        event_detail.multipleSelect('refresh');
        event_detail.trigger('change');
    }

    /**
     * イベント詳細内訳ドロップダウンリストを更新します。
     * @param {*} messages
     */
    function refreshDropdownListEvents(messages)
    {
        /** イベント区分条件の取得 */
        let event_types = {
            1: !!$('#event_type_1').prop('checked'),  // イベント区分(1.作業)
            2: !!$('#event_type_2').prop('checked'),  // イベント区分(2.警告)
            3: !!$('#event_type_3').prop('checked'),  // イベント区分(3.撮影)
            4: !!$('#event_type_4').prop('checked'),  // イベント区分(4.定期送信)
        };

        /** イベント詳細内訳欄の更新 */
        let target_event_types = [];
        if (event_types[1]) {
            target_event_types.push(1);
        }
        if (event_types[2]) {
            target_event_types.push(2);
        }
        if (event_types[3]) {
            target_event_types.push(3);
        }
        if (event_types[4]) {
            target_event_types.push(4);
        }
        createDropdownListEvents(_movement_locus_data_['dropdown_events'], target_event_types, messages)
    }

    /**
     * 検索結果リストの列ヘッダ押下時のイベント処理を行います。
     * @param {*} type
     * @param {*} column_id
     */
    function onClickThInfoList(type, column_id)
    {
        let tr = $('#info_list_table thead tr');
        if (tr) {
            let sort_column = column_id.replace('#th_', '');
            let sort_type = (tr.find(column_id).hasClass('sorting') || tr.find(column_id).hasClass('sorting_desc') ? 1 : 2);
            /** 並べ替えデータ取得 */
            _movement_locus_data_['list_events'] = getSortDataEvents(_movement_locus_data_['list_events'], sort_column, sort_type);

            // init
            _zMapMain.mapLocus.closeInfoboxEventAll();
            _zMapMain.mapLocus.closeInfoboxDestinationAll();

            /** 並べ替えデータでリストを再作成 */
            createInfoList(_movement_locus_data_, _movement_locus_settings_.messages);

            /** 並べ替えアイコンを設定 */
            setSortIconInfoListEvents(sort_column, sort_type);

            /** 指定条件でイベントリストのフィルター設定 */
            setFilterInfoListEvents();

        }
        return false;
    }

    /**
     * 検索結果リスト(イベント)の並べ替えアイコンを設定します。
     * @param {*} sort_column
     * @param {*} sort_type
     */
    function setSortIconInfoListEvents(sort_column, sort_type)
    {
        let listSettings = _movement_locus_settings_.messages.info_list;
        let tr = $('#info_list_table thead tr');
        if (tr) {
            // init
            tr.find('th').not('.sorting_disabled').removeClass('sorting_asc').removeClass('sorting_desc').addClass('sorting');
            // set
            $.each(listSettings, function(key, value) {
                if (value.hasOwnProperty('sorting') && value.sorting === true && key === sort_column) {
                    tr.find('#th_' + key).removeClass('sorting').addClass((sort_type === 1 ? 'sorting_asc' : 'sorting_desc'));
                    return false;
                }
            });
        }
        return false;
    }

    /**
     * 検索結果リスト(イベント)の並べ替えデータを取得します。
     * @param {*} list
     * @param {*} sort_column
     * @param {*} sort_type
     */
    function getSortDataEvents(list, sort_column, sort_type)
    {
        let data    = $.extend(true, {}, list);
        data = Object.keys(data).map(key => data[key]);

        sort_column = ((sort_column || '').toString() == 'event_time' || (sort_column || '').toString() == 'event_name' || (sort_column || '').toString() == 'event_type') ? sort_column : 'event_time';
        sort_type   = ((sort_type || '').toString() == '1' || (sort_type || '').toString() == '2') ? sort_type : 1;

        switch(sort_column){

            case 'event_time':     // 1.発生日時
                if ((sort_type || '').toString() == '1') {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 発生日時(raw) */
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') < moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return -1;
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') > moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return 1;
                        /** イベントID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        /** イベント区分 */
                        if((item1.event_type || '').toString() < (item2.event_type || '').toString()) return -1;
                        if((item1.event_type || '').toString() > (item2.event_type || '').toString()) return 1;
                        /** イベント種別ID */
                        if((item1.event_id || '').toString() < (item2.event_id || '').toString()) return -1;
                        if((item1.event_id || '').toString() > (item2.event_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 発生日時(raw) */
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') > moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return -1;
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') < moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return 1;
                        /** イベントID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        /** イベント区分 */
                        if((item1.event_type || '').toString() > (item2.event_type || '').toString()) return -1;
                        if((item1.event_type || '').toString() < (item2.event_type || '').toString()) return 1;
                        /** イベント種別ID */
                        if((item1.event_id || '').toString() > (item2.event_id || '').toString()) return -1;
                        if((item1.event_id || '').toString() < (item2.event_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'event_name':     // 2.イベント名
                if ((sort_type || '').toString() == '1') {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** イベント種別ID */
                        if((item1.event_id || '').toString() < (item2.event_id || '').toString()) return -1;
                        if((item1.event_id || '').toString() > (item2.event_id || '').toString()) return 1;
                        /** 発生日時(raw) */
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') < moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return -1;
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') > moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return 1;
                        /** イベントID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        /** イベント区分 */
                        if((item1.event_type || '').toString() < (item2.event_type || '').toString()) return -1;
                        if((item1.event_type || '').toString() > (item2.event_type || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** イベント種別ID */
                        if((item1.event_id || '').toString() > (item2.event_id || '').toString()) return -1;
                        if((item1.event_id || '').toString() < (item2.event_id || '').toString()) return 1;
                        /** 発生日時(raw) */
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') > moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return -1;
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') < moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return 1;
                        /** イベントID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        /** イベント区分 */
                        if((item1.event_type || '').toString() > (item2.event_type || '').toString()) return -1;
                        if((item1.event_type || '').toString() < (item2.event_type || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'event_type':     // 3.イベント区分
                if ((sort_type || '').toString() === '1') {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** イベント区分 */
                        if((item1.event_type || '').toString() < (item2.event_type || '').toString()) return -1;
                        if((item1.event_type || '').toString() > (item2.event_type || '').toString()) return 1;
                        /** 発生日時(raw) */
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') < moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return -1;
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') > moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return 1;
                        /** イベントID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        /** イベント種別ID */
                        if((item1.event_id || '').toString() < (item2.event_id || '').toString()) return -1;
                        if((item1.event_id || '').toString() > (item2.event_id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** イベント区分 */
                        if((item1.event_type || '').toString() > (item2.event_type || '').toString()) return -1;
                        if((item1.event_type || '').toString() < (item2.event_type || '').toString()) return 1;
                        /** 発生日時(raw) */
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') > moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return -1;
                        if(moment(item1.time).format('YYYY/MM/DD HH:mm:ss') < moment(item2.time).format('YYYY/MM/DD HH:mm:ss')) return 1;
                        /** イベントID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        /** イベント種別ID */
                        if((item1.event_id || '').toString() > (item2.event_id || '').toString()) return -1;
                        if((item1.event_id || '').toString() < (item2.event_id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;
        }
        return data;
    }

    /**
     * エラーメッセージをセットします。
     * @param {*} errors
     */
    function setErrorMessage(errors)
    {
        resetErrorMessage();
        if (errors) {
            // if(errors.hasOwnProperty('section_id')){
            //     $('#helpblock_section_id').parent().parent().addClass('has-error');
            //     $('#helpblock_section_id').addClass('help-block-error');
            //     $('#helpblock_section_id').text(errors['section_id'][0]);
            // }
            // if(errors.hasOwnProperty('movement_vehicle_code')){
            //     $('#helpblock_vehicle_code').parent().parent().addClass('has-error');
            //     $('#helpblock_vehicle_code').addClass('help-block-error');
            //     $('#helpblock_vehicle_code').text(errors['movement_vehicle_code'][0]);
            // } else if(errors.hasOwnProperty('movement_vehicle_name')){
            //     $('#helpblock_vehicle_code').parent().parent().addClass('has-error');
            //     $('#helpblock_vehicle_code').addClass('help-block-error');
            //     $('#helpblock_vehicle_code').text(errors['movement_vehicle_name'][0]);
            // }
            // if(errors.hasOwnProperty('movement_time__from')){
            //     $('#helpblock_time_range').parent().parent().addClass('has-error');
            //     $('#helpblock_time_range').addClass('help-block-error');
            //     $('#helpblock_time_range').text(errors['movement_time__from'][0]);
            // } else if (errors.hasOwnProperty('movement_time__to')) {
            //     $('#helpblock_time_range').parent().parent().addClass('has-error');
            //     $('#helpblock_time_range').addClass('help-block-error');
            //     $('#helpblock_time_range').text(errors['movement_time__to'][0]);
            // }
            // if(errors.hasOwnProperty('movement_record_id')){
            //     $('#helpblock_record_id').parent().parent().addClass('has-error');
            //     $('#helpblock_record_id').addClass('help-block-error');
            //     $('#helpblock_record_id').text(errors['movement_record_id'][0]);
            // }
        }
    }

    /**
     * エラーメッセージをリセットします。
     */
    function resetErrorMessage()
    {
        // $('#helpblock_section_id').parent().parent().removeClass('has-error');
        // $('#helpblock_vehicle_code').parent().parent().removeClass('has-error');
        // $('#helpblock_time_range').parent().parent().removeClass('has-error');
        // $('#helpblock_record_id').parent().parent().removeClass('has-error');

        // $('#helpblock_section_id').removeClass('help-block-error');
        // $('#helpblock_vehicle_code').removeClass('help-block-error');
        // $('#helpblock_time_range').removeClass('help-block-error');
        // $('#helpblock_record_id').removeClass('help-block-error');

        // $('#helpblock_section_id').text('');
        // $('#helpblock_vehicle_code').text('');
        // $('#helpblock_time_range').text('');
        // $('#helpblock_record_id').text('');
    }

    /**
    * 走行軌跡の絞り込み条件デフォルト値の設定処理を行います。
    */
    function setDefaultLocusFilterData()
    {
        let action = _movement_locus_settings_.url_set_default_locus_filter_data;
        let event_types = {
            1: !!$('#event_type_1').prop('checked'),  // イベント区分(1.作業)
            2: !!$('#event_type_2').prop('checked'),  // イベント区分(2.警告)
            3: !!$('#event_type_3').prop('checked'),  // イベント区分(3.撮影)
            4: !!$('#event_type_4').prop('checked'),  // イベント区分(4.定期送信)
        };
        let data = {event_types: event_types};

        $('#locus_filter_event_types').val(JSON.stringify(event_types));
        // 保存
        _ajax.post(action, data, function(result) {
            // 何もしない
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    }

    /**
     * 日報修正からジャンプした場合(起動モード1)の事前処理を行います。
     */
    function presetMode1()
    {
        /** 起動モード判定 */
        let mode = $('#menu_mode').val() || '';
        if (mode !== '1') {
            /** 起動モード1でない場合は何もしない */
            return;
        }

        /** 各検索条件欄の非活性化 */
        $('#section_id').prop('disabled', true);
        $('#vehicle_code').prop('disabled', true);
        $('#vehicle_id').prop('disabled', true);
        $('#time_range').prop('disabled', true);
        $('#record_id').prop('disabled', true);

        /** 検索ボタン、クリアボタンの非表示化 */
        $('#search_button').addClass('d-none');
        $('#clear_button').addClass('d-none');
    }

    /**
     * 日報修正からジャンプした場合(起動モード1)の初期表示処理を行います。
     */
    function setInputMode1()
    {
        /** 起動モード判定 */
        if (($('#menu_mode').val() || '') !== '1') {
            /** 起動モード1でない場合は何もしない */
            return;
        }

        /** 内部変数初期化 */
        _movement_locus_data_ = false;

        /** エラーメッセージ表示のリセット */
        resetErrorMessage();

        /** 地図表示リセット */
        resetMap(true);
        /** 情報リスト初期化処理 */
        initializeInfoList();
        /** 絞り込み条件欄の初期化 */
        clearInputFilterEvents();

        /** 走行軌跡データ取得 */
        getMovementLocusData();
    }
}

